import React, { FC } from 'react'
import { animated } from 'react-spring'
import { Summary } from './summary'
import { Accordion, Grid } from '@mui/material'
import { DeviceTermsProps } from 'interfaces/quota'
import { DetailsAccordion } from './details-accordion'
import useFadeInFromAvobe from 'hooks/useFadeInFromAvobe'

const MobileTerms: FC<DeviceTermsProps> = ({
  onClick,
  open,
  doubt,
}) => {

  const props1 = useFadeInFromAvobe(250)
  const props2 = useFadeInFromAvobe(500)
  const props3 = useFadeInFromAvobe(750)
  const props4 = useFadeInFromAvobe(1000)
  const props5 = useFadeInFromAvobe(1250)
  const props6 = useFadeInFromAvobe(1500)

  const propsArray = [props1, props2, props3, props4, props5, props6]

  return (
    <Grid container>
      {doubt.map((term, index) => (
        <Grid key={index} item xs={12}>
          <animated.div style={propsArray[index]}>
            <Accordion
              className="borderMonths bp-my-8"
              expanded={open === index}
              onChange={() => onClick(index, open === index)}
            >
              <Summary open={open} index={index} term={term} />
              <DetailsAccordion term={term} />
            </Accordion>
          </animated.div>
        </Grid>
      ))}
    </Grid>
  )
}

export default MobileTerms
